import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {CalendarModule} from 'ap-angular2-fullcalendar';
import {AddressModule} from '../address/address.module';
import {InterpreterComponent} from './interpreter.component';

@NgModule({
  imports: [AddressModule, CalendarModule, CommonModule, FormsModule, RouterModule],
  declarations: [InterpreterComponent],
  exports: [InterpreterComponent],
})
export class InterpreterModule {}



// WEBPACK FOOTER //
// ./src/app/shared/ui/interpreter/interpreter.module.ts